// components/CreateRacquetForm.tsx
import React, { useState } from 'react';
import { Box, Grid, TextField, Button, Stack } from '@mui/material';

interface Props {
    onSave: (data: { brand: string; model: string }) => void;
    onCancel: () => void;
    initialBrand?: string;
    initialModel?: string;
  }

export default function CreateRacquetForm({
    onSave,
    onCancel,
    initialBrand = '',
    initialModel = ''
}: Props) {
    const [brand, setBrand] = useState(initialBrand);
    const [model, setModel] = useState(initialModel);
    
    const handleSubmit = () => {
        if (!brand || !model) {
          alert('Brand and Model are required');
          return;
        }
        onSave({ brand, model });
      };
    
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Brand"
                        value={brand}
                        onChange={(e) => setBrand(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Model"
                        value={model}
                        onChange={(e) => setModel(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 2 }}>
                <Button variant="text" onClick={onCancel}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmit}>Save</Button>
            </Stack>
        </Box>
    );
}
